module.exports = __webpack_public_path__ + "img/logoteczoav1.03037cfc.png";